import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import styled, { withTheme } from "styled-components";
import {
  profiles,
  studies,
  studiesIds,
  USER_GUIDES_BASE_URL,
} from "../../../modules/constants";
import {
  mapDispatchToPropsLayout,
  mapStateToPropsLayout,
} from "../../../modules/layout";
import { mapStateToPropsLogin } from "../../../modules/login";
import ImgXLH from "../../../assets/sidebar-icons/XLH.svg";
import ImgCommunity from "../../../assets/sidebar-icons/Rarify Community.svg";
import { useTranslation } from "react-i18next";
import { getCurrentLocale } from "../../../i18n/helpers";
import SideBarItem from "./SideBarItem/SideBarItem";

const StyledNavbar = styled.nav`
  background-color: ${({ theme }) => theme?.white};
  color: ${({ theme }) => theme?.fg};
  margin-left: -30px;
  margin-top: -30px;

  & > .list-unstyled {
    margin-bottom: 0px;
  }
`;

const Sidebar = (props) => {
  const {
    showLayoutSidebar,
    isSidebarCollapsed,
    userProfile,
    studyId,
    claims,
    canViewComments,
  } = props;

  const sidebarRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (sidebarRef) {
      if (isSidebarCollapsed) {
        sidebarRef.current.className = sidebarRef.current.className.replace(
          " active",
          ""
        );
      } else {
        sidebarRef.current.className += ` ${
          !isSidebarCollapsed ? "active" : ""
        }`;
      }
    }
  }, [isSidebarCollapsed]);

  const getProfileUrl = () => {
    if (userProfile === profiles.participant) {
      return "/participant";
    } else if (userProfile === profiles.contentAdmin) {
      return "/content-admin";
    } else if (userProfile === profiles.itAdmin) {
      return "/management";
    }
    return "/participant";
  };

  const getUserProfileDescription = () => {
    if ([profiles.participant, profiles.contentAdmin].includes(userProfile)) {
      return studyId?.toLocaleLowerCase() ===
        studiesIds.beyondxlh402.toLocaleLowerCase()
        ? t("appText.sidebar.content")
        : t("appText.sidebar.rare.journey");
    } else if (userProfile === profiles.itAdmin) {
      return "Users";
    }
    return "Profile";
  };

  const userMainPage = (profileType, userStudies) => {
    if (userStudies) {
      if (
        userStudies.indexOf(studies.lcfaod402) > -1 &&
        profileType === profiles.contentAdmin
      ) {
        return (
          <li
            className={
              props.location.pathname === "/content-admin" ? "active" : null
            }
          >
            <SideBarItem
              linkTo={getProfileUrl()}
              title={getUserProfileDescription()}
              isSidebarCollapsed={isSidebarCollapsed}
            >
              <img
                src={ImgCommunity}
                alt="Community"
                width="36px"
                height="24px"
                className={`svg-img ${
                  props.location.pathname === "/content-admin" ? "active" : null
                }`}
              />
            </SideBarItem>
          </li>
        );
      } else {
        return null;
      }
    }
  };

  const reportPage = (profileType, userStudies) => {
    if (userStudies) {
      if (
        userStudies.indexOf(studies.xlh) > -1 &&
        profileType === profiles.contentAdmin
      ) {
        return (
          <li className={props.location.pathname === "/xlh" ? "active" : null}>
            <SideBarItem
              linkTo="/xlh"
              title="XLH"
              isSidebarCollapsed={isSidebarCollapsed}
            >
              <img
                src={ImgXLH}
                alt="XLH"
                width="36px"
                height="24px"
                className={`svg-img ${
                  props.location.pathname === "/xlh" ? "active" : ""
                }`}
              />
            </SideBarItem>
          </li>
        );
      }
    } else {
      return null;
    }
  };

  return (
    <>
      <StyledNavbar ref={sidebarRef} id="sidebar" className="sidebar-shadow">
        {props.userProfile === profiles.participant &&
          studiesIds.lcfaod402.toLocaleLowerCase() ===
            studyId?.toLocaleLowerCase() && (
            <ul className="list-unstyled components">
              <li
                className={
                  props.location.pathname === "/" ||
                  props.location.pathname === "/home"
                    ? "active"
                    : ""
                }
              >
                <SideBarItem
                  linkTo="/"
                  title="Home"
                  iconClass="fas fa-home"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
              <li
                className={
                  props.location.pathname === "/dashboard" ? "active" : ""
                }
              ></li>
              <li
                className={
                  props.location.pathname === "/participant" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo={getProfileUrl()}
                  title={getUserProfileDescription()}
                  isSidebarCollapsed={isSidebarCollapsed}
                  iconClass="fas fa-file-medical-alt"
                />
              </li>
              <li
                className={
                  props.location.pathname === "/diet-diary" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo="/diet-diary"
                  title={t("appText.dietDiary")}
                  iconClass="fas fa-utensils"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
              <li
                className={props.location.pathname === "/stats" ? "active" : ""}
              >
                <SideBarItem
                  linkTo="/stats"
                  title={t("appText.stats")}
                  iconClass="fas fa-chart-pie"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
              <li
                className={
                  props.location.pathname === "/favorites" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo="/favorites"
                  title={t("appText.favorites")}
                  iconClass="fas fa-star"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
            </ul>
          )}
        {props.userProfile === profiles.participant &&
          studiesIds.beyondxlh402.toLocaleLowerCase() ===
            studyId?.toLocaleLowerCase() && (
            <ul className="list-unstyled components">
              <li
                className={
                  props.location.pathname === "/" ||
                  props.location.pathname === "/home"
                    ? "active"
                    : ""
                }
              >
                <SideBarItem
                  linkTo="/"
                  title="Home"
                  iconClass="fas fa-home"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
              <li
                className={
                  props.location.pathname === "/dashboard" ? "active" : ""
                }
              ></li>
              <li
                className={
                  props.location.pathname === "/participant" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo={getProfileUrl()}
                  title={getUserProfileDescription()}
                  isSidebarCollapsed={isSidebarCollapsed}
                >
                  <img
                    src={ImgCommunity}
                    alt="Community"
                    width="36px"
                    height="24px"
                    className={`svg-img ${
                      props.location.pathname === "/participant" ? "active" : ""
                    }`}
                  />
                </SideBarItem>
              </li>
            </ul>
          )}
        {props.userProfile === profiles.participant &&
          studyId?.toLocaleLowerCase() ===
            studiesIds.gsdiii.toLocaleLowerCase() && (
            <ul className="list-unstyled components">
              <li
                className={
                  props.location.pathname === "/participant" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo="/participant"
                  title={t("appText.dietDiary")}
                  iconClass="fas fa-utensils"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
              <li
                className={props.location.pathname === "/stats" ? "active" : ""}
              >
                <SideBarItem
                  linkTo="/stats"
                  title={t("appText.stats")}
                  iconClass="fas fa-chart-pie"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>

              <li
                className={
                  props.location.pathname === "/favorites" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo="/favorites"
                  title={t("appText.favorites")}
                  iconClass="fas fa-star"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>

              <li>
                <a
                  href={`${USER_GUIDES_BASE_URL}ux053_cl101_study_user_guide_${getCurrentLocale()}.pdf`}
                  target="_blank"
                  rel="noreferrer noopener"
                  download
                >
                  <i className="fas fa-info-circle" aria-hidden="true"></i>
                  {!isSidebarCollapsed && <span>{t("appText.userGuide")}</span>}
                </a>
              </li>
            </ul>
          )}
        {/* TODO: Need dynamic buttons for dynamic routes*/}
        {props.userProfile === profiles.participant &&
          studyId?.toLocaleLowerCase() ===
            studiesIds.lcfaod401.toLocaleLowerCase() && (
            <ul className="list-unstyled components">
              <li
                className={
                  props.location.pathname === "/participant" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo="/participant"
                  title={t("appText.dietDiary")}
                  iconClass="fas fa-utensils"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
              <li
                className={props.location.pathname === "/stats" ? "active" : ""}
              >
                <SideBarItem
                  linkTo="/stats"
                  title={t("appText.stats")}
                  iconClass="fas fa-chart-pie"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
              <li
                className={
                  props.location.pathname === "/favorites" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo="/favorites"
                  title={t("appText.favorites")}
                  iconClass="fas fa-star"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
            </ul>
          )}
        {/* If not participant */}
        {props.userProfile !== profiles.participant && (
          <ul className="list-unstyled components">
            <li
              className={props.location.pathname === `/admin` ? "active" : ""}
            >
              <SideBarItem
                linkTo="/admin"
                title="Home"
                isSidebarCollapsed={isSidebarCollapsed}
              >
                <img
                  alt=""
                  src={ImgCommunity}
                  width="36px"
                  height="24px"
                  className={`svg-img ${
                    props.location.pathname === `/admin` ? "active" : ""
                  }`}
                />
              </SideBarItem>
            </li>
            {claims?.includes("mealLog.changeRequest.canView") &&
              studyId?.toLocaleLowerCase() ===
                studiesIds.gsdiii.toLocaleLowerCase() && (
                <li
                  className={
                    props.location.pathname === "/change-requests"
                      ? "active"
                      : ""
                  }
                >
                  <SideBarItem
                    linkTo="/change-requests"
                    title="Change requests"
                    iconClass="fas fa-exchange-alt fa-lg"
                    isSidebarCollapsed={isSidebarCollapsed}
                  />
                </li>
              )}

            {canViewComments && (
              <li
                className={
                  props.location.pathname === "/data-comments" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo="/data-comments"
                  title="Data Comments"
                  iconClass="fas fa-comment-alt fa-lg"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
            )}
          </ul>
        )}
        <ul className="list-unstyled components">
          {userMainPage(props.userProfile, props.studies)}
          {reportPage(props.userProfile, props.studies)}
        </ul>

        {claims?.includes("charts.canView") &&
          studiesIds.beyondxlh402.toLocaleLowerCase() && (
            <ul className="list-unstyled components">
              <li
                className={
                  props.location.pathname === "/charts" ? "active" : ""
                }
              >
                <SideBarItem
                  linkTo="/charts"
                  title={t("appText.sidebar.surveyCharts")}
                  iconClass="fas fa-chart-bar fa-lg"
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </li>
            </ul>
          )}
      </StyledNavbar>
    </>
  );
};

const mapStateToProps = (state) => ({
  ...mapStateToPropsLogin(state),
  ...mapStateToPropsLayout(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToPropsLayout
)(withRouter(withTheme(Sidebar)));
